module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "markdown-container",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Textarea")]), _vm._v(" "), _c('md-textarea', {
    staticClass: "markdown-textarea",
    model: {
      value: (_vm.mdVal),
      callback: function($$v) {
        _vm.mdVal = $$v
      },
      expression: "mdVal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "parse-container",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlVal)
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f17610e6"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/MarkDown.vue
// module id = 360
// module chunks = 1